/**
 * i18n Initialization
 * Configures i18next with all necessary plugins
 */

import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'
import { DEFAULT_LANGUAGE, NAMESPACES, getSupportedLanguageCodes } from './config'

void i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: getSupportedLanguageCodes(),
    defaultNS: 'common',
    ns: NAMESPACES,

    interpolation: {
      escapeValue: false, // React already escapes
    },

    detection: {
      // Order of language detection (querystring first for SEO hreflang links)
      order: ['querystring', 'localStorage', 'navigator'],
      // Cache detected language in localStorage
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      // Query parameter name for language
      lookupQuerystring: 'lang',
    },

    backend: {
      // Path to translation files
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    react: {
      // No loading indicator; instant fallback to cached/English translations
      useSuspense: false,
    },

    // Debugging (disable in production)
    debug: import.meta.env.DEV,
  })

// Log initial language detection for debugging
if (import.meta.env.DEV) {
  console.log('[i18n] Initialized with language:', i18n.language)
  console.log('[i18n] Supported languages:', getSupportedLanguageCodes())
}

export default i18n
